(function () {
  var API_URL = 'https://api.judge.me/api/v1/reviews';
  var ALLOWED_PHOTO_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/heic',
    'image/heif',
  ];
  var MAX_DIMENSION = 2048;
  var COMPRESS_QUALITIES = [0.85, 0.75, 0.65, 0.55, 0.5];

  function showMessage(form, type, text) {
    var existing = form.querySelector('[data-feedback-message]');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.setAttribute('data-feedback-message', '');
    el.setAttribute('role', type === 'error' ? 'alert' : 'status');
    el.className = 'feedback-form-message feedback-form-message--' + type;
    el.textContent = text;
    form.insertBefore(el, form.firstChild);
  }

  function setLoading(form, loading, label) {
    var btn = form.querySelector('[data-feedback-submit]');
    if (!btn) return;
    btn.classList.toggle('is-loading', loading);
    btn.disabled = loading;
    if (loading) {
      btn.setAttribute('data-original-label', btn.textContent);
      btn.textContent = label || btn.getAttribute('data-loading-label') || 'Submitting…';
    } else if (btn.getAttribute('data-original-label')) {
      btn.textContent = btn.getAttribute('data-original-label');
    }
  }

  function buildBody(text, phone) {
    var body = (text || '').trim();
    if (phone && phone.trim()) {
      body += (body ? '\n\n' : '') + 'Phone: ' + phone.trim();
    }
    return body;
  }

  function parseErrorResponse(data) {
    if (!data) return null;
    if (typeof data.message === 'string') return data.message;
    if (data.error) return String(data.error);
    if (data.errors) {
      if (Array.isArray(data.errors)) return data.errors.join(', ');
      if (typeof data.errors === 'object') {
        return Object.keys(data.errors)
          .map(function (key) {
            return key + ': ' + data.errors[key];
          })
          .join(', ');
      }
    }
    return null;
  }

  function getUploadConfig(form) {
    if (form.getAttribute('data-upload-enabled') !== 'true') return null;

    return {
      url: form.getAttribute('data-upload-url') || '/apps/feedback-upload/upload',
      maxPhotos: parseInt(form.getAttribute('data-max-photos') || '5', 10),
      maxFileSizeMb: parseInt(form.getAttribute('data-max-file-size-mb') || '4', 10),
      uploadingLabel: form.getAttribute('data-uploading-label') || 'Uploading photos…',
      compressingLabel:
        form.getAttribute('data-compressing-label') || 'Processing photos…',
      typeError: form.getAttribute('data-photo-type-error') || 'Unsupported file type.',
      sizeError: form.getAttribute('data-photo-size-error') || 'File is too large.',
      countError: form.getAttribute('data-photo-count-error') || 'Too many photos.',
      uploadError: form.getAttribute('data-photo-upload-error') || 'Photo upload failed.',
    };
  }

  function createPhotoState(form) {
    var wrapper = form.querySelector('[data-feedback-photos]');
    if (!wrapper) return null;

    var config = getUploadConfig(form);
    if (!config) return null;

    return {
      form: form,
      wrapper: wrapper,
      config: config,
      input: wrapper.querySelector('[data-feedback-photo-input]'),
      addButton: wrapper.querySelector('[data-feedback-photo-add]'),
      dropzone: wrapper.querySelector('[data-feedback-photo-dropzone]'),
      list: wrapper.querySelector('[data-feedback-photo-list]'),
      status: wrapper.querySelector('[data-feedback-photo-status]'),
      files: [],
      previews: [],
      processing: false,
    };
  }

  function renderPhotoList(state) {
    if (!state.list) return;

    state.list.innerHTML = '';
    state.previews.forEach(function (preview) {
      if (preview.objectUrl) URL.revokeObjectURL(preview.objectUrl);
    });
    state.previews = [];

    if (!state.files.length) {
      state.list.hidden = true;
      updatePhotoStatus(state);
      return;
    }

    state.list.hidden = false;

    state.files.forEach(function (file) {
      var item = document.createElement('li');
      item.className = 'feedback-photos-item';

      var thumb = document.createElement('img');
      thumb.className = 'feedback-photos-thumb';
      thumb.alt = file.name;
      var objectUrl = URL.createObjectURL(file);
      thumb.src = objectUrl;
      state.previews.push({ objectUrl: objectUrl });

      var name = document.createElement('span');
      name.className = 'feedback-photos-name';
      name.textContent = file.name;

      var removeButton = document.createElement('button');
      removeButton.type = 'button';
      removeButton.className = 'feedback-photos-remove button-unstyled';
      removeButton.setAttribute('aria-label', 'Remove photo');
      removeButton.textContent = '×';
      removeButton.addEventListener('click', function () {
        var fileIndex = state.files.indexOf(file);
        if (fileIndex === -1) return;
        state.files.splice(fileIndex, 1);
        renderPhotoList(state);
      });

      item.appendChild(thumb);
      item.appendChild(name);
      item.appendChild(removeButton);
      state.list.appendChild(item);
    });

    updatePhotoStatus(state);
  }

  function updatePhotoStatus(state) {
    if (!state.status) return;

    if (!state.files.length) {
      state.status.hidden = true;
      state.status.textContent = '';
      return;
    }

    var label =
      state.files.length === 1
        ? '1 photo ready to upload'
        : state.files.length + ' photos ready to upload';
    state.status.hidden = false;
    state.status.textContent = label;
  }

  function setPhotoProcessing(state, processing) {
    state.processing = processing;
    if (state.addButton) {
      state.addButton.disabled = processing;
      state.addButton.classList.toggle('is-processing', processing);
    }
    if (state.input) {
      state.input.disabled = processing;
    }
  }

  function validatePhotoType(file, config) {
    if (ALLOWED_PHOTO_TYPES.indexOf(file.type) !== -1) {
      return null;
    }

    if (file.type && file.type.indexOf('image/') === 0) {
      return null;
    }

    if (/\.(jpe?g|png|webp|gif|heic|heif)$/i.test(file.name || '')) {
      return null;
    }

    return config.typeError;
  }

  function loadImageFromFile(file) {
    return new Promise(function (resolve, reject) {
      var objectUrl = URL.createObjectURL(file);
      var image = new Image();

      image.onload = function () {
        URL.revokeObjectURL(objectUrl);
        resolve(image);
      };

      image.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Invalid image file'));
      };

      image.src = objectUrl;
    });
  }

  function canvasToBlob(canvas, quality) {
    return new Promise(function (resolve) {
      canvas.toBlob(
        function (blob) {
          resolve(blob);
        },
        'image/jpeg',
        quality
      );
    });
  }

  function buildCompressedFileName(originalName) {
    var baseName = (originalName || 'photo').replace(/\.[^.]+$/, '');
    return baseName + '.jpg';
  }

  function compressImage(file, config) {
    var maxBytes = config.maxFileSizeMb * 1024 * 1024;

    if (file.size <= maxBytes && file.type === 'image/jpeg') {
      return loadImageFromFile(file).then(function (image) {
        if (
          image.naturalWidth <= MAX_DIMENSION &&
          image.naturalHeight <= MAX_DIMENSION
        ) {
          return file;
        }
        return compressWithCanvas(image, file.name, maxBytes);
      });
    }

    return loadImageFromFile(file).then(function (image) {
      return compressWithCanvas(image, file.name, maxBytes);
    });
  }

  function compressWithCanvas(image, originalName, maxBytes) {
    var scale = Math.min(
      1,
      MAX_DIMENSION / Math.max(image.naturalWidth, image.naturalHeight)
    );
    var width = Math.max(1, Math.round(image.naturalWidth * scale));
    var height = Math.max(1, Math.round(image.naturalHeight * scale));
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    canvas.width = width;
    canvas.height = height;
    context.drawImage(image, 0, 0, width, height);

    var qualityIndex = 0;

    function tryNextQuality() {
      var quality = COMPRESS_QUALITIES[qualityIndex];
      return canvasToBlob(canvas, quality).then(function (blob) {
        if (!blob) {
          throw new Error('Photo compression failed');
        }

        var isLastQuality = qualityIndex >= COMPRESS_QUALITIES.length - 1;
        if (blob.size <= maxBytes || isLastQuality) {
          if (blob.size > maxBytes) {
            throw new Error('Photo is too large after compression');
          }

          return new File([blob], buildCompressedFileName(originalName), {
            type: 'image/jpeg',
            lastModified: Date.now(),
          });
        }

        qualityIndex += 1;
        return tryNextQuality();
      });
    }

    return tryNextQuality();
  }

  function addPhotoFiles(state, fileList) {
    var i;
    var file;
    var typeError;
    var incoming = [];

    if (!fileList || !fileList.length) return;

    if (state.files.length + fileList.length > state.config.maxPhotos) {
      throw new Error(state.config.countError);
    }

    for (i = 0; i < fileList.length; i += 1) {
      file = fileList[i];
      if (!file) continue;

      typeError = validatePhotoType(file, state.config);
      if (typeError) {
        throw new Error(typeError);
      }

      incoming.push(file);
    }

    if (!incoming.length) return;

    incoming.forEach(function (nextFile) {
      state.files.push(nextFile);
    });

    renderPhotoList(state);
  }

  function preventDragDefaults(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function bindPhotoUpload(form, state) {
    if (!state || state.bound) return;
    state.bound = true;

    function handleSelectedFiles(files) {
      if (!files || !files.length || state.processing) return;

      try {
        addPhotoFiles(state, files);
      } catch (error) {
        showMessage(form, 'error', error.message || state.config.uploadError);
      }
    }

    if (state.addButton && state.input) {
      state.addButton.addEventListener('click', function () {
        if (state.processing) return;
        state.input.click();
      });

      state.input.addEventListener('change', function (event) {
        handleSelectedFiles(event.target.files);
        event.target.value = '';
      });
    }

    if (state.dropzone) {
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (eventName) {
        state.dropzone.addEventListener(eventName, preventDragDefaults);
      });

      state.dropzone.addEventListener('dragenter', function () {
        state.dropzone.classList.add('is-dragover');
      });

      state.dropzone.addEventListener('dragover', function () {
        state.dropzone.classList.add('is-dragover');
      });

      state.dropzone.addEventListener('dragleave', function () {
        state.dropzone.classList.remove('is-dragover');
      });

      state.dropzone.addEventListener('drop', function (event) {
        state.dropzone.classList.remove('is-dragover');
        handleSelectedFiles(event.dataTransfer.files);
      });
    }

    form._feedbackPhotoState = state;
  }

  function uploadPhoto(state, file) {
    return compressImage(file, state.config)
      .catch(function () {
        if (file.size <= state.config.maxFileSizeMb * 1024 * 1024) {
          return file;
        }
        throw new Error(state.config.sizeError);
      })
      .then(function (compressed) {
        var formData = new FormData();
        formData.append('file', compressed, compressed.name);

        return fetch(state.config.url, {
          method: 'POST',
          body: formData,
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            if (result.ok && result.data && result.data.url) {
              return result.data.url;
            }

            throw new Error(
              (result.data && result.data.error) || state.config.uploadError
            );
          });
      });
  }

  function uploadPhotos(state) {
    if (!state.files.length) {
      return Promise.resolve([]);
    }

    return Promise.all(
      state.files.map(function (file) {
        return uploadPhoto(state, file);
      })
    );
  }

  function resetPhotoState(state) {
    if (!state) return;
    state.files = [];
    renderPhotoList(state);
    if (state.input) state.input.value = '';
    setPhotoProcessing(state, false);
  }

  function submitReview(form, payload) {
    var params = new URLSearchParams();
    params.append('shop_domain', payload.shopDomain);
    params.append('platform', 'shopify');
    params.append('name', payload.name);
    params.append('email', payload.email);
    params.append('rating', String(payload.rating));
    params.append('body', payload.body);

    if (payload.productId && payload.productId !== 'website') {
      params.append('id', payload.productId);
    }

    payload.pictureUrls.forEach(function (url) {
      params.append('picture_urls[]', url);
    });

    return fetch(API_URL, {
      method: 'POST',
      body: params,
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, status: response.status, data: data };
        });
      })
      .then(function (result) {
        if (result.ok || result.status === 201 || (result.data && result.data.review)) {
          form.setAttribute('data-feedback-success', 'true');
          form.reset();
          resetPhotoState(form._feedbackPhotoState);
          showMessage(form, 'success', form.getAttribute('data-success-message'));
          return;
        }

        var message =
          parseErrorResponse(result.data) ||
          form.getAttribute('data-error-message');
        showMessage(form, 'error', message);
      });
  }

  function handleSubmit(event) {
    event.preventDefault();
    var form = event.currentTarget;

    if (form.getAttribute('data-feedback-success') === 'true') return;

    var honeypot = form.querySelector('[data-feedback-honeypot]');
    if (honeypot && honeypot.value) return;

    var nameInput = form.querySelector('[data-feedback-name]');
    var emailInput = form.querySelector('[data-feedback-email]');
    var phoneInput = form.querySelector('[data-feedback-phone]');
    var productInput = form.querySelector('[data-feedback-product]');
    var bodyInput = form.querySelector('[data-feedback-body]');
    var ratingInput = form.querySelector('[data-feedback-rating]:checked');
    var photoState = form._feedbackPhotoState;

    if (photoState && photoState.processing) return;

    var name = nameInput ? nameInput.value.trim() : '';
    var email = emailInput ? emailInput.value.trim() : '';
    var phone = phoneInput ? phoneInput.value.trim() : '';
    var productId = productInput ? productInput.value.trim() : '';
    var body = bodyInput ? bodyInput.value.trim() : '';
    var rating = ratingInput ? parseInt(ratingInput.value, 10) : 0;

    if (!name || !email || !body || !rating) {
      form.reportValidity();
      return;
    }

    var shopDomain =
      (window.Shopify && window.Shopify.shop) ||
      form.getAttribute('data-shop-domain');

    var uploadConfig = getUploadConfig(form);
    var loadingLabel = form.getAttribute('data-loading-label') || 'Submitting…';

    setLoading(form, true, loadingLabel);
    var existingMsg = form.querySelector('[data-feedback-message]');
    if (existingMsg) existingMsg.remove();

    var uploadPromise = photoState
      ? (function () {
          if (photoState.files.length) {
            setLoading(form, true, uploadConfig.uploadingLabel);
          }
          return uploadPhotos(photoState);
        })()
      : Promise.resolve([]);

    uploadPromise
      .then(function (pictureUrls) {
        if (photoState && photoState.files.length) {
          setLoading(form, true, loadingLabel);
        }

        return submitReview(form, {
          shopDomain: shopDomain,
          name: name,
          email: email,
          rating: rating,
          body: buildBody(body, phone),
          productId: productId,
          pictureUrls: pictureUrls,
        });
      })
      .catch(function (error) {
        showMessage(
          form,
          'error',
          (error && error.message) ||
            (uploadConfig && uploadConfig.uploadError) ||
            form.getAttribute('data-error-message')
        );
      })
      .finally(function () {
        setLoading(form, false);
      });
  }

  function getProductParamForUrl(select) {
    var value = select.value;
    if (!value) return null;
    if (value === 'website') return 'website';

    var selected = select.options[select.selectedIndex];
    var handle = selected && selected.getAttribute('data-product-handle');
    return handle || value;
  }

  function syncProductToUrl(select) {
    if (!window.history || !window.history.replaceState) return;

    var url = new URL(window.location.href);
    var productParam = getProductParamForUrl(select);

    if (productParam) {
      url.searchParams.set('product', productParam);
    } else {
      url.searchParams.delete('product');
    }

    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
  }

  function handleProductChange(event) {
    syncProductToUrl(event.currentTarget);
  }

  function applyProductFromUrl(form) {
    var select = form.querySelector('[data-feedback-product]');
    if (!select) return;

    var urlParams = new URLSearchParams(window.location.search);
    var productParam = urlParams.get('product');
    if (!productParam) return;

    productParam = productParam.trim();
    if (!productParam) return;

    if (productParam === 'website') {
      select.value = 'website';
      return;
    }

    var options = select.querySelectorAll('option');
    var i;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === productParam) {
        select.value = productParam;
        return;
      }
    }

    for (i = 0; i < options.length; i++) {
      if (options[i].getAttribute('data-product-handle') === productParam) {
        select.value = options[i].value;
        return;
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-feedback-form]').forEach(function (form) {
      applyProductFromUrl(form);

      if (form.getAttribute('data-feedback-initialized') !== 'true') {
        form.setAttribute('data-feedback-initialized', 'true');
        form.addEventListener('submit', handleSubmit);

        var productSelect = form.querySelector('[data-feedback-product]');
        if (productSelect) {
          productSelect.addEventListener('change', handleProductChange);
        }
      }

      var photoState = createPhotoState(form);
      if (photoState) {
        bindPhotoUpload(form, photoState);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
